<template>
  <div class="table-tdrow">
    <div class="table-td wp20">{{center.name}}</div>
    <div class="table-td wp20">{{center.cost.toFixed(2)}}</div>
  </div>
</template>

<script>
export default {
  props: ['center'],
};
</script>
